import { useEffect, useState, useSyncExternalStore } from 'react';

import {
  createVoiceRecordingPort,
  type ResponderVoiceRecordingPort,
} from './shared-responder-v2-voice-recording-port';
import type { SignedUploadRequest } from './shared-responder-v2-voice-recording.helpers';

// test-exception: React binding only — every transition lives in createVoiceRecordingPort and its helpers, covered by shared-responder-v2-voice-recording.helpers.spec.ts.
/**
 * `requestSignedUpload` is read once, when the port is built: each app supplies
 * its own schema's upload mutation, closing over an Apollo client whose identity
 * never changes. `isAnonymous` is likewise fixed for the life of a session, so
 * rebuilding the port on it is a formality that keeps the flag out of a ref
 * rather than a real re-acquisition path.
 */
export function useResponderVoiceRecordingPort(
  requestSignedUpload: SignedUploadRequest,
  isAnonymous: boolean
): ResponderVoiceRecordingPort {
  const [runtime] = useState(() =>
    createVoiceRecordingPort(requestSignedUpload, isAnonymous)
  );

  const snapshot = useSyncExternalStore(
    runtime.subscribe,
    runtime.getSnapshot,
    runtime.getSnapshot
  );

  useEffect(() => () => void runtime.actions.stop(), [runtime]);

  return { ...snapshot, ...runtime.actions };
}
